import React from "react";


import "./index.scss";


interface BlackoutComponentProps {
    children?: React.ReactNode | React.ReactNode[];
}


export const BlackoutComponent:React.FC<BlackoutComponentProps> = ({
    children
}) => {

    return (
        <div className={'blackout-component'}>
            {children}
        </div>
    )

};


export default BlackoutComponent;
